import SEO from "./SEO";
import SEOConfig, { publisherRef } from "./SEOConfig";

/**
 * SEO component for the Videos page
 * Enhanced with keywords, breadcrumbs, and improved structured data
 *
 * @param {Object} props - Component props
 * @param {string} props.url - The URL of the videos page
 */
const VideosSEO = ({ url }) => {
  const { siteUrl } = SEOConfig;
  const title = "Відео: огляди, трансляції, інтерв'ю";
  const description =
    "Огляди гонок, трансляції, інтерв'ю та інші відеоматеріали від Slick Racing Ukraine. Дивіться найкращі моменти та аналіз гоночних подій.";

  // For absolute URLs in meta tags
  const fullUrl = url ? (url.startsWith("http") ? url : `${siteUrl}${url}`) : `${siteUrl}/videos`;

  // Add relevant keywords for the videos page
  const keywords = [
    "Slick Racing Ukraine відео",
    "симрейсинг трансляції",
    "сімрейсінг трансляції",
    "віртуальний автоспорт огляди",
    "iRacing відео",
    "гоночні огляди",
    "інтерв'ю з пілотами",
    "гоночні трансляції",
  ];

  // Define breadcrumbs for better navigation and SEO
  const breadcrumbs = [
    {
      name: "Головна",
      url: siteUrl,
    },
    {
      name: "Медіа",
      url: fullUrl,
    },
  ];

  // Enhanced structured data for the video gallery
  const schema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: title,
    description: description,
    url: fullUrl,
    mainEntity: {
      "@type": "ItemList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Огляди",
          url: `${fullUrl}/seasons/9`,
          description: "Огляди гонок та найкращі моменти сезону",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Трансляції",
          url: `${fullUrl}/streams`,
          description: "Повні трансляції гонок та кваліфікацій",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "Інтерв'ю",
          url: `${fullUrl}/conversations`,
          description: "Інтерв'ю з пілотами та організаторами",
        },
      ],
    },
    publisher: publisherRef,
  };

  return (
    <SEO
      title={title}
      description={description}
      keywords={keywords}
      url={fullUrl}
      schema={schema}
      canonical={fullUrl}
      type="website"
      breadcrumbs={breadcrumbs}
      lang="uk"
    />
  );
};

export default VideosSEO;
